import { useSurveySegmentClient } from "../contexts/SurveySegmentClientContext";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import useDeviceType from "./useDeviceType";
import { useEnvConfig } from "@redux/slices/globalSlice";
import { appConfig } from "@utils/analytics";
import { Platform } from "react-native";

export const useSurveyAnalytics = () => {
  const surveySegmentClient = useSurveySegmentClient();
  const userInfo = useUserInfo();
  const { isDesktop, isMobile } = useDeviceType();
  const env = useEnvConfig();

  const getUserAnalyticsPayload = () => {
    const user = userInfo?.user;

    // Get platform from environment config, fallback to Platform.OS detection
    const getPlatform = () => {
      if (env?.platform) {
        return env.platform;
      }
      // Fallback to Platform.OS detection
      return Platform.OS;
    };

    return {
      user_id: user?.id || null,
      user_name: user ? `${user.first_name} ${user.last_name}` : null,
      user_email: user?.email || null,
      user_country: user?.country || null,
      device_type: isMobile ? "mobile" : isDesktop ? "desktop" : "ipad",
      platform: getPlatform(),
      ...appConfig,
    };
  };

  const trackSurveyEvent = (eventName: string, properties?: any) => {
    if (!surveySegmentClient) {
      console.warn("Survey segment client not initialized");
      return;
    }

    const userAnalyticsPayload = getUserAnalyticsPayload();

    surveySegmentClient.track(eventName, {
      ...userAnalyticsPayload,
      ...properties,
    });
  };

  const trackCloseSurveyForm = (properties?: any) => {
    trackSurveyEvent("survey_popup_close_action", properties);
  };

  const trackShareFeedbackNextTimeAction = (properties?: any) => {
    trackSurveyEvent("needs_work_next_time_action", properties);
  };

  const trackCloseNeedsWorkPopup = (properties?: any) => {
    trackSurveyEvent("needs_work_popup_close_action", properties);
  };

  const trackLoveItAction = (properties?: any) => {
    trackSurveyEvent("survey_love_it_action", properties);
  };

  const trackNeedsWorkAction = (properties?: any) => {
    trackSurveyEvent("survey_needs_work_action", properties);
  };

  const trackShareFeedbackAction = (properties?: any) => {
    trackSurveyEvent("needs_work_share_feedback_action", properties);
  };

  return {
    trackSurveyEvent,
    trackCloseSurveyForm,
    trackShareFeedbackNextTimeAction,
    trackCloseNeedsWorkPopup,
    trackLoveItAction,
    trackNeedsWorkAction,
    trackShareFeedbackAction,
  };
};
